import React from 'react';

export const FieldErrorMessages: React.FC<{
  messages: (string | undefined)[];
}> = (props) => {
  const messages = props.messages.filter(Boolean) as string[];
  return messages.length > 0 ? (
    <div>
      {messages.map((message, index) => (
        <p key={index} className="text-[--c-error]" role="alert">
          {message}
        </p>
      ))}
    </div>
  ) : null;
};
